import React from 'react';
import { Typography } from '@ha/dsl';

export const Label: React.FC = ({ children, ...props }) => (
  <Typography.H3 color="inherit" noWrap {...props}>
    {children}
  </Typography.H3>
);

export default Label;
